<template>
  <div class="supplement-procurement-page">
    <el-card class="page-card">
      <div slot="header" class="card-header">
        <h2>增补采购</h2>
      </div>
      <div class="page-content">
        <p>增补采购页面内容</p>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'SupplementProcurement',
  data() {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>

<style scoped>
.supplement-procurement-page {
  padding: 20px;
}

.page-card {
  min-height: 500px;
}

.card-header h2 {
  margin: 0;
  color: #333;
}

.page-content {
  padding: 20px 0;
}
</style>
